import React from 'react'
import Productpage from '../components/Productpage/Productpage'

function Product() {
  return (
    <div>
     
      <Productpage/>
      
    </div>
  )
}

export default Product
